import React, { Fragment, useState, useRef } from 'react'
import { Button, Col, FormGroup, Row, Table, CardBody, Card, CardHeader, Label, Input, Media } from 'reactstrap'
import { useCashGlobal } from '../../hooks/cash/useCashGlobal'
import 'moment/locale/es';
import "react-datetime/css/react-datetime.css";
import './styleCash.css';
import { useCash } from '../../hooks/cash/useCash'
import { ModalAuthorizationCash } from './ModalAuthorizationCash';
import { ToolTips } from '../../components/tooltips/ToolTips';
import { Dialog } from 'primereact/dialog';
import { ConfigServer } from '../../data/config'
import { CustomAlertDialogGlobal } from '../alertDialog/CustomAlertDialogGlobal';
import { ToastAletGlobal } from '../alertDialog/ToastAletGlobal';
import { Modal, useModal } from "react-morphing-modal";
import "react-morphing-modal/dist/ReactMorphingModal.css";







export const IndexCashFlowGlobal = () => {

    let branchs = localStorage.getItem('branchName');
    const urlHelen = localStorage.getItem('url_helen');

    const {
        // ? CONFIGURATION
        _commercialLine, _nameUser, _branchName, _new, _admin_cash,

        // ? FORM 
        date1, date2, handleInputChange,

        // ? TYPE FORMAT
        formatter,

        // ? GLOBAL CASH
        dataAllGlobal, handleGetGlobalCash, amount1, loadingGlobal, amountTotal, amountCancell,

        // ? AUTHORIZATION CASH
        handleSearchAuthorization, selectedKey, toogleAuthorization, modalAuthorization, handleOpenPreview, handleClosedPreview, viewDetail, viewAmount, user, id_cash, saveCourtesyPatient,


        // ? EXTEMPORANEOUS
        visibleTicket, showModalTicket, hideModalTicket, infoTicket, toast, userCapture,
        handleComment, handleAmount, formextemporaneus, createExtemporaneous, loadingExtemporaneous,

        showEvidence, setShowEvidence,
        listPayMethod, showAlert, cancelTabChange,
        printTicket2, loadingPrintKey,
        showToast, toastType, toastTitle, toastMessage, closeToastAlert,
        showModalModifiedAmount, visibleInfo,
        hideModalAmount,
        formNewAmount,
        handleCommentModified, handleAmountModified,
        saveModifiedCashFlow,
        loadingModified








    } = useCashGlobal();

    const {

        //*CONFIGURATION CASH
        loading, printTicket, downloadExcelCredits, downloadExcelOthers

    } = useCash();


    // const { modalProps, open, close } = useModal();

    const { close, modalProps, open } = useModal({
        onClose: () => setKey(key => key + 1),
        background: "#fff"

    });

    const modalFullRef = useRef(null);

    const [key, setKey] = useState(0);


    const handleReport = (receptor) => {


        open(modalFullRef);
    }







    // #region CONFIGURATION TABLE
    // ? CONFIGURATIOM REPORT
    const [expandedRows, setExpandedRows] = useState({});
    const [expandedRows2, setExpandedRows2] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    var _total_amount = 0;
    var _fech = "";



    // ? METHODS
    const toggleRow = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const toggleRow2 = (rowKey) => {
        setExpandedRows2(prev => ({
            ...prev,
            [rowKey]: !prev[rowKey]
        }));
    };

    // const toggleRow2 = (_key_user, _key_branch) => {
    //     const key = `${_key_user}-${_key_branch}`;

    //     setExpandedRows2((prevState) => {
    //         const newState = { ...prevState };

    //         if (newState[key]) {
    //             delete newState[key];
    //         } else {
    //             newState[key] = true;
    //         }

    //         return newState;
    //     });
    // };

    const totalCaptureAmount = dataAllGlobal.reduce((total, _branch) => {
        return total + _branch?.detailBranches.reduce((branchTotal, _user) => {
            return branchTotal + _user.cash.reduce((userTotal, _detail) => {
                return userTotal + _detail?.captureAmount;
            }, 0);
        }, 0);
    }, 0);

    const handleRowSelect = (branchId) => {
        setSelectedRow(branchId);
    };
    // #endregion 



    // ? TABLE
    const totalAmountCash = (
        <tr>
            <td></td>
            <td style={{ height: '10px', textAlign: "end", fontWeight: "bold", fontSize: "11px" }}>Total Global</td>
            <td style={{ backgroundColor: '#013553', height: '10px', textAlign: "right", color: "#fff" }}>
                {formatter.format(amount1)}
            </td>
            <td style={{ backgroundColor: '#013553', height: '10px', textAlign: "right", color: "#fff" }}>
                {formatter.format(amountCancell)}
            </td>
            <td style={{ backgroundColor: '#013553', height: '10px', textAlign: "right", color: "#fff" }}>
                {formatter.format(amountTotal)}
            </td>
            <td style={{ backgroundColor: '#013553', height: '10px', textAlign: "right", color: "#fff" }}>
                {formatter.format(totalCaptureAmount)}
            </td>
        </tr>
    );

    const footerContent = <>
        <Button disabled={loadingExtemporaneous ? true : false} size="sm" color="secondary" type="button" onClick={() => createExtemporaneous(_fech)}  >{"Generar corte"}</Button>
        <Button disabled={loadingExtemporaneous ? true : false} size="sm" className="btn-air-light" color="danger" type="button" onClick={hideModalTicket}>Cancelar</Button>
    </>


    const footerContentDetail = <>
        <Button disabled={loadingModified ? true : false} size="sm" color="secondary" type="button" onClick={() => saveModifiedCashFlow()} > {"Generar modificación"}</Button>
        <Button disabled={loadingModified ? true : false} size="sm" className="btn-air-light" color="danger" type="button" onClick={hideModalAmount}>Cancelar</Button>
    </>

    const [historicChanges, setHistoricChanges] = useState([]);


    const openEvidence = (historicChange) => {
        console.log("🚀 ~ openEvidence ~ historicChange:", historicChange)
        if (!historicChange || historicChange.length === 0) return;

        setHistoricChanges(historicChange);
        setShowEvidence(true);
    };


    const [showMovementDialog, setShowMovementDialog] = useState(false);


    const headerCompact = {
        backgroundColor: "#002940",
        color: "#fff",
        fontWeight: "600",
        fontSize: "10px",
        padding: "6px 8px",
        lineHeight: "1.1",
        textAlign: "center",
        verticalAlign: "middle",
        whiteSpace: "normal"
    };
    const [selectedUserBranch, setSelectedUserBranch] = React.useState(0);



    const cashDashboard = React.useMemo(() => {
        const branches = Array.isArray(dataAllGlobal)
            ? dataAllGlobal
            : [];

        let compliantBranches = 0;
        let differenceBranches = 0;
        let pendingBranches = 0;
        let cancelledBranches = 0;
        let emptyBranches = 0;

        let totalRegistered = 0;
        let totalCancelled = 0;
        let totalExpected = 0;
        let totalDelivered = 0;

        const branchIndicators = branches.map((branch) => {
            const registered = Number(branch?.amount || 0);
            const cancelled = Number(branch?.amount_cancell || 0);
            const expected = Number(branch?.amount_total || 0);
            const delivered = Number(branch?.amountCash || 0);

            const detailBranches = Array.isArray(branch?.detailBranches)
                ? branch.detailBranches
                : [];


            const usersCutStatus = detailBranches.map((user) => {
                const cash = Array.isArray(user?.cash)
                    ? user.cash
                    : [];

                const cashCut = Array.isArray(user?.cashCut)
                    ? user.cashCut
                    : [];

                const cashPending = Array.isArray(user?.cashPending)
                    ? user.cashPending
                    : [];

                const amount = Number(user?.amount || 0);
                const amountCut = Number(user?.amount_cut || 0);
                const amountPending = Number(user?.amount_pending || 0);


                const hasMovements =
                    amount > 0 ||
                    amountCut > 0 ||
                    amountPending > 0 ||
                    cash.length > 0 ||
                    cashCut.length > 0 ||
                    cashPending.length > 0;

                const hasPendingStatus = cash.some((detail) => {
                    const status = String(detail?.status || "")
                        .trim()
                        .toLowerCase();

                    return status === "pendiente";
                });

                const hasPendingSales = cash.some(
                    (detail) =>
                        detail?.has_pending_sales === true
                );

                const hasPending =
                    amountPending > 0 ||
                    cashPending.length > 0 ||
                    hasPendingStatus ||
                    hasPendingSales;


                const completedInCash = cash.some((detail) => {
                    const status = String(detail?.status || "")
                        .trim()
                        .toLowerCase();

                    return (
                        Number(detail?.id_cash || 0) > 0 &&
                        status !== "pendiente"
                    );
                });

                const hasCompleted =
                    amountCut > 0 ||
                    cashCut.length > 0 ||
                    completedInCash;


                const isComplete =
                    hasCompleted &&
                    !hasPending;

                return {
                    ...user,
                    hasMovements,
                    hasPending,
                    hasCompleted,
                    isComplete
                };
            });


            const evaluableUsers = usersCutStatus.filter(
                (user) => user.hasMovements
            );


            const completedUsers = evaluableUsers.filter(
                (user) => user.isComplete
            );

            const totalUsersToCut = evaluableUsers.length;
            const totalCompletedUsers = completedUsers.length;


            const percentage =
                totalUsersToCut > 0
                    ? Math.min(
                        Math.max(
                            (
                                totalCompletedUsers /
                                totalUsersToCut
                            ) * 100,
                            0
                        ),
                        100
                    )
                    : 0;


            const hasPendingCuts = evaluableUsers.some(
                (user) => user.hasPending
            );

            const hasCompletedCuts = evaluableUsers.some(
                (user) => user.hasCompleted
            );


            const allCutsCompleted =
                totalUsersToCut > 0 &&
                totalCompletedUsers === totalUsersToCut;


            const hasMovements =
                registered > 0 ||
                expected > 0 ||
                delivered > 0 ||
                cancelled > 0 ||
                totalUsersToCut > 0;

            const difference =
                expected - delivered;

            const isBalanced =
                totalUsersToCut > 0 &&
                allCutsCompleted &&
                !hasPendingCuts &&
                Math.abs(difference) < 0.01;

            let status = "";
            let statusClass = "";
            let icon = "";

            if (
                expected === 0 &&
                cancelled > 0 &&
                delivered === 0 &&
                !hasPendingCuts
            ) {
                status = "Cancelado";
                statusClass = "cancelled";
                icon = "fa fa-times";

                cancelledBranches++;
            }

            else if (
                !hasMovements &&
                !hasCompletedCuts
            ) {
                status = "Sin movimientos";
                statusClass = "empty";
                icon = "fa fa-minus";

                emptyBranches++;
            }


            else if (
                hasPendingCuts ||
                !allCutsCompleted
            ) {
                status = "Pendiente";
                statusClass = "pending";
                icon = "fa fa-clock-o";

                pendingBranches++;
            }


            else if (isBalanced) {
                status = "Cumplido";
                statusClass = "success";
                icon = "fa fa-check";

                compliantBranches++;
            }

            else {
                status =
                    difference > 0
                        ? "Entrega incompleta"
                        : "Entrega excedida";

                statusClass = "warning";
                icon = "fa fa-exclamation-triangle";

                differenceBranches++;
            }

            totalRegistered += registered;
            totalCancelled += cancelled;
            totalExpected += expected;
            totalDelivered += delivered;

            return {
                ...branch,

                registered,
                cancelled,
                expected,
                delivered,
                difference,

                hasMovements,
                hasPendingCuts,
                hasCompletedCuts,
                allCutsCompleted,
                isBalanced,

                totalUsersToCut,
                totalCompletedUsers,
                pendingUsers:
                    totalUsersToCut - totalCompletedUsers,

                status,
                statusClass,
                icon,
                percentage
            };
        });


        const evaluableBranches =
            branches.length -
            cancelledBranches -
            emptyBranches;

        const compliancePercentage =
            evaluableBranches > 0
                ? (
                    compliantBranches /
                    evaluableBranches
                ) * 100
                : 0;

        return {
            totalBranches: branches.length,

            compliantBranches,
            differenceBranches,
            pendingBranches,
            cancelledBranches,
            emptyBranches,

            compliancePercentage,

            totalRegistered,
            totalCancelled,
            totalExpected,
            totalDelivered,

            totalDifference:
                totalExpected - totalDelivered,

            branchIndicators
        };
    }, [dataAllGlobal]);

    const userCashDashboard = React.useMemo(() => {
        const branches = Array.isArray(dataAllGlobal)
            ? dataAllGlobal
            : [];

        const usersMap = new Map();

        branches.forEach((branch) => {
            const users = Array.isArray(branch?.detailBranches)
                ? branch.detailBranches
                : [];

            users.forEach((user) => {
                const userId = user?.id_user;
                const userName =
                    user?.cash?.find(item => item?.user_capture)?.user_capture ||
                    user?.name_user ||
                    user?.user ||
                    "Usuario sin nombre";

                const userKey = `${branch?.id_branch}-${userId}`;

                if (!usersMap.has(userKey)) {
                    usersMap.set(userKey, {
                        id_user: userId,
                        id_branch: branch?.id_branch,
                        branch: branch?.branch || "Sucursal sin nombre",
                        userName,

                        totalCuts: 0,
                        completedCuts: 0,
                        pendingCuts: 0,
                        balancedCuts: 0,
                        differenceCuts: 0,
                        validatedCuts: 0,

                        registeredAmount: 0,
                        deliveredAmount: 0,
                        differenceAmount: 0,

                        cuts: []
                    });
                }

                const currentUser = usersMap.get(userKey);

                const cuts = Array.isArray(user?.cash)
                    ? user.cash
                    : [];

                cuts.forEach((detail, detailIndex) => {
                    const registeredAmount = Number(detail?.amount || 0);
                    const deliveredAmount = Number(detail?.captureAmount || 0);
                    const difference = registeredAmount - deliveredAmount;

                    const isPending = detail?.status === "Pendiente";

                    const isBalanced =
                        !isPending &&
                        Math.abs(difference) < 0.01;

                    const isValidated =
                        Boolean(detail?.validate_cash_flow) &&
                        detail?.validate_cash_flow !== "";

                    currentUser.totalCuts++;

                    currentUser.registeredAmount += registeredAmount;
                    currentUser.deliveredAmount += deliveredAmount;

                    if (isPending) {
                        currentUser.pendingCuts++;
                    } else {
                        currentUser.completedCuts++;
                        currentUser.differenceAmount += difference;
                    }

                    if (isBalanced) {
                        currentUser.balancedCuts++;
                    }

                    if (!isPending && !isBalanced) {
                        currentUser.differenceCuts++;
                    }

                    if (isValidated) {
                        currentUser.validatedCuts++;
                    }

                    currentUser.cuts.push({
                        ...detail,
                        detailIndex,
                        registeredAmount,
                        deliveredAmount,
                        difference,
                        isPending,
                        isBalanced,
                        isValidated
                    });
                });
            });
        });

        const users = Array.from(usersMap.values()).map((user) => {
            let status = "";
            let statusClass = "";
            let icon = "";

            if (user.totalCuts === 0) {
                status = "Sin cortes";
                statusClass = "empty";
                icon = "fa fa-minus";
            } else if (
                user.pendingCuts === 0 &&
                user.differenceCuts === 0 &&
                user.balancedCuts === user.totalCuts
            ) {
                status = "Cumplido";
                statusClass = "success";
                icon = "fa fa-check";
            } else if (user.differenceCuts > 0) {
                status = "Con diferencia";
                statusClass = "warning";
                icon = "fa fa-exclamation-triangle";
            } else {
                status = "Pendiente";
                statusClass = "pending";
                icon = "fa fa-clock-o";
            }

            const compliancePercentage =
                user.totalCuts > 0
                    ? (user.balancedCuts / user.totalCuts) * 100
                    : 0;

            const validationPercentage =
                user.completedCuts > 0
                    ? (user.validatedCuts / user.completedCuts) * 100
                    : 0;

            return {
                ...user,
                status,
                statusClass,
                icon,
                compliancePercentage,
                validationPercentage
            };
        });

        const totalUsers = users.length;

        const compliantUsers = users.filter(
            user => user.status === "Cumplido"
        ).length;

        const pendingUsers = users.filter(
            user => user.status === "Pendiente"
        ).length;

        const usersWithDifference = users.filter(
            user => user.status === "Con diferencia"
        ).length;

        const totalCuts = users.reduce(
            (total, user) => total + user.totalCuts,
            0
        );

        const totalBalancedCuts = users.reduce(
            (total, user) => total + user.balancedCuts,
            0
        );

        const generalCompliance =
            totalUsers > 0
                ? (compliantUsers / totalUsers) * 100
                : 0;

        return {
            users,
            totalUsers,
            compliantUsers,
            pendingUsers,
            usersWithDifference,
            totalCuts,
            totalBalancedCuts,
            generalCompliance
        };
    }, [dataAllGlobal]);


    const usersDashboardFiltered = React.useMemo(() => {
        if (selectedUserBranch === 0) {
            return userCashDashboard.users;
        }

        return userCashDashboard.users.filter(
            user => Number(user.id_branch) === Number(selectedUserBranch)
        );
    }, [userCashDashboard.users, selectedUserBranch]);

    const userBranchOptions = React.useMemo(() => {
        const branches = Array.isArray(dataAllGlobal)
            ? dataAllGlobal
            : [];

        return [
            {
                label: "Todas las sucursales",
                value: 0
            },
            ...branches.map(branch => ({
                label: branch?.branch || "Sucursal sin nombre",
                value: branch?.id_branch
            }))
        ];
    }, [dataAllGlobal]);


    const isWithin24Hours = (fechCashFlow) => {
        if (!fechCashFlow) return false;

        try {
            const match = fechCashFlow.match(/(\d{4})-(\d{2})-(\d{2})\s+(\d{1,2}):(\d{2}):(\d{2})\s*(a\.?\s*m\.?|p\.?\s*m\.?)/i);

            if (!match) {
                return false;
            }

            const [
                ,
                year,
                month,
                day,
                hourString,
                minute,
                second,
                period
            ] = match;

            let hour = Number(hourString);

            const isPM = period.toLowerCase().replace(/\s/g, "").startsWith("p");

            const isAM = period.toLowerCase().replace(/\s/g, "").startsWith("a");

            if (isPM && hour !== 12) {
                hour += 12;
            }

            if (isAM && hour === 12) {
                hour = 0;
            }

            const cashFlowDate = new Date(Number(year), Number(month) - 1, Number(day), hour, Number(minute), Number(second));

            const now = new Date();

            const differenceMilliseconds =
                now.getTime() - cashFlowDate.getTime();

            const twentyFourHours =
                24 * 60 * 60 * 1000;

            return (
                differenceMilliseconds >= 0 &&
                differenceMilliseconds <= twentyFourHours
            );

        } catch (error) {
            console.error("Error validando fecha de corte:", error);
            return false;
        }
    };


    return (
        <Fragment>
            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <div >
                    <Card style={{
                        marginBottom: '15px',
                        background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }}>
                        <CardBody style={{ padding: '18px 25px' }}>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '15px'
                                    }}>
                                        <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/cash-money.svg")} style={{ width: "60px", height: "60px" }} />
                                    </div>
                                    <div>
                                        <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                            Detallado de cortes
                                        </h4>
                                        <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                            <i className="fa fa-info-circle mr-1"></i>
                                            Detallado de los cortes realizados por los usuarios activos al dia.
                                        </small>
                                    </div>
                                </div>

                            </div>
                        </CardBody>
                    </Card>
                    {
                        // * INFORMATION
                    }
                    <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                        <Col sm="12" className='pt-3'>
                            <Row>
                                <Col sm="2" className='p-l-0 p-r-0 pt-4' style={{ textAlign: "left" }}>
                                    <Card style={{
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        border: 'none',
                                        height: '100%',
                                        borderRadius: '12px'
                                    }}>
                                        <CardHeader style={{
                                            background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                            color: 'white',
                                            padding: '15px',
                                            borderRadius: '12px 12px 0 0'
                                        }}>
                                            <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                                <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                            </h6>
                                        </CardHeader>
                                        <CardBody style={{ padding: '20px' }}>
                                            <FormGroup>
                                                <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
                                                    <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                                </Label>
                                                <Input
                                                    style={{ borderColor: "#fff", borderStyle: "solid", borderWidth: "1px", borderRadius: "15px", height: "35px", fontSize: "11px" }}
                                                    type='date'
                                                    className='border-0 mr-2'
                                                    name='date1'
                                                    value={date1}
                                                    onChange={(e) => handleInputChange(e)}
                                                >
                                                </Input>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
                                                    <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                                </Label>
                                                <Input
                                                    style={{ borderColor: "#fff", borderStyle: "solid", borderWidth: "1px", borderRadius: "15px", height: "35px", fontSize: "11px" }}
                                                    type='date'
                                                    className='border-0 mr-2'
                                                    name='date2'
                                                    value={date2}
                                                    onChange={(e) => handleInputChange(e)}
                                                >
                                                </Input>
                                            </FormGroup>

                                            <Button
                                                onClick={() => handleGetGlobalCash()}

                                                color="primary"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                {loading ? (
                                                    <>
                                                        <i className='pi pi-spin pi-spinner mr-2'></i>Buscando...
                                                    </>
                                                ) : (
                                                    <>
                                                        Buscar
                                                    </>
                                                )}
                                            </Button>


                                            <div ref={modalFullRef}  >.</div>

                                            <Button
                                                color="dark"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: "10px",
                                                    padding: "6px",
                                                    fontSize: "14px",
                                                    fontWeight: 600,
                                                    borderWidth: "2px"
                                                }}
                                                onClick={() => handleReport()}
                                                onMouseEnter={(e) =>
                                                    (e.currentTarget.style.transform = "translateY(-2px)")
                                                }
                                                onMouseLeave={(e) =>
                                                    (e.currentTarget.style.transform = "translateY(0)")
                                                }
                                            >
                                                {loading ? (
                                                    <>
                                                        <i className="pi pi-spin pi-spinner mr-2"></i>
                                                        Buscando...
                                                    </>
                                                ) : (
                                                    <>Indicadores</>
                                                )}
                                            </Button>


                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col sm="10">
                                    {
                                        // * GLOBAL INDICATORS
                                    }
                                    <div style={{
                                        marginTop: '20px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        backgroundColor: '#fff'
                                    }}>
                                        <Table striped size="sm">
                                            <thead>
                                                <tr>
                                                    <th style={{ backgroundColor: "#1d5b83", color: "#ffffff", fontWeight: "bold" }}>#</th>
                                                    <th style={{ backgroundColor: "#1d5b83", color: "#ffffff", fontWeight: "bold" }}>Sucursal</th>
                                                    <th style={{ backgroundColor: "#1d5b83", color: "#ffffff", fontWeight: "bold" }}>Efectivo Total</th>
                                                    <th style={{ backgroundColor: "#1d5b83", color: "#ffffff", fontWeight: "bold" }}>Efectivo Cancelado</th>
                                                    <th style={{ backgroundColor: "#1d5b83", color: "#ffffff", fontWeight: "bold" }}>Efectivo Final</th>
                                                    <th style={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold" }}>Monto Entregado</th>
                                                    <th style={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", textAlign: "center" }}>Estatus</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    loadingGlobal && <tr>
                                                        <td colSpan={7} className='bg-info text-center f-16'>
                                                            <i className="fa fa-spin fa-spinner"></i> Cargando...
                                                        </td>
                                                    </tr>
                                                }
                                                {!loadingGlobal && dataAllGlobal.length > 0 && dataAllGlobal.map((_branch, _key) => {
                                                    let totalBranchAmount = 0;
                                                    let totalBranchAmount2 = 0;

                                                    let totalBranchCaptureAmount = 0;
                                                    // let _sum = 0;
                                                    //  let _difference = _branch?.amount - _branch?.amountCash;

                                                    const isSelected = selectedRow === _branch?.id_branch;
                                                    return (
                                                        <React.Fragment key={_key}>
                                                            <tr style={{ backgroundColor: isSelected ? "#6c757d24" : "white", cursor: 'pointer' }}
                                                                onClick={() => handleRowSelect(_branch?.id_branch)}
                                                            >
                                                                <td>
                                                                    <span onClick={() => toggleRow(_key)} style={{ cursor: 'pointer' }}>
                                                                        {expandedRows[_key] ? (
                                                                            <i className="txt-secondary f-22 fa fa-minus-square"></i>
                                                                        ) : (
                                                                            <i className="txt-secondary f-22 fa fa-plus-square"></i>
                                                                        )}
                                                                    </span>
                                                                </td>
                                                                <td>{_branch?.branch}</td>
                                                                <td style={{ textAlign: "right" }} >{formatter.format(_branch?.amount)}</td>
                                                                <td style={{ textAlign: "right" }} className={_branch?.amount_cancell === 0 ? "" : 'txt-danger'}    >{formatter.format(_branch?.amount_cancell)}</td>
                                                                <td style={{ textAlign: "right" }}   >{formatter.format(_branch?.amount_total)}</td>
                                                                <td style={{ textAlign: "right" }}>{formatter.format(_branch?.amountCash)}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {(() => {
                                                                        const total = Number(_branch?.amount || 0);
                                                                        const cancelado = Number(_branch?.amount_cancell || 0);
                                                                        const entregado = Number(_branch?.amountCash || 0);
                                                                        const diferencia = total - entregado;

                                                                        if (diferencia === 0) {
                                                                            return <i className='fa fa-check txt-success f-20' title="Corte cuadrado"></i>;
                                                                        }

                                                                        if (total > 0 && total === cancelado && entregado === 0) {
                                                                            return (
                                                                                <i
                                                                                    className='fa fa-times text-danger f-20'
                                                                                    title="Todo el monto fue cancelado"
                                                                                ></i>
                                                                            );
                                                                        }
                                                                        return (
                                                                            <i
                                                                                className='fa fa-exclamation-triangle txt-warning f-20'
                                                                                title="Diferencia en corte"
                                                                            ></i>

                                                                        );
                                                                    })()}
                                                                </td>
                                                            </tr>

                                                            {expandedRows[_key] && (
                                                                <tr>
                                                                    <td colSpan="7">
                                                                        <Table striped size="sm">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={headerCompact}>Acciones</th>
                                                                                    <th style={headerCompact}>Usuario</th>
                                                                                    <th style={headerCompact}>Efectivo Registrado en sistema</th>
                                                                                    <th style={headerCompact}>Efectivo Entregado en corte</th>
                                                                                    <th style={headerCompact}>Diferencia</th>
                                                                                    <th style={headerCompact}>Fecha de corte</th>
                                                                                    <th style={headerCompact}>Estatus del corte</th>
                                                                                    <th style={headerCompact}>Recibido</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody >
                                                                                {_branch?.detailBranches.length > 0 && _branch?.detailBranches.map((_user, _key_user) => (
                                                                                    _user?.cash.length > 0 && _user?.cash.map((_detail, _key_detail) => {
                                                                                        console.log("🚀 ~ IndexCashFlowGlobal ~ _detail:", _detail)
                                                                                        // ////
                                                                                        const hasModifiedAmount = _detail?.user_modified_amount !== null && _detail?.user_modified_amount !== undefined && _detail?.user_modified_amount !== "";

                                                                                        let difference = hasModifiedAmount ? Number(_detail?.modified_amount ?? 0) - Number(_detail?.amount ?? 0) : Number(_detail?.amount ?? 0) - Number(_detail?.captureAmount ?? 0);


                                                                                        // let difference = _detail?.amount - _detail?.captureAmount;
                                                                                        totalBranchCaptureAmount += _detail?.captureAmount;
                                                                                        totalBranchAmount2 += _detail?.amount
                                                                                        const isSelected = selectedKey === `${_user?.id_user}-${_branch?.id_branch}-${_key_detail}` ? 1 : 0
                                                                                        // const listPayMethods = _detail?.status === "Pendiente"
                                                                                        //     ? _user?.pay_methods_pending
                                                                                        //     : _user?.pay_methods_cut;


                                                                                        // const listPayMethods = _detail?.status === "Pendiente"
                                                                                        //     ? (_user?.pay_methods_pending ?? [])
                                                                                        //     : (
                                                                                        //         _detail?.pay_methods?.length > 0
                                                                                        //             ? _detail.pay_methods
                                                                                        //             : (_user?.pay_methods_cut ?? [])
                                                                                        //     );


                                                                                        console.log("USUARIO COMPLETO:", _user);
                                                                                        console.log("CORTES DEL USUARIO:", _user?.cash);
                                                                                        console.log("🚀 ~ IndexCashFlowGlobal ~ _detail:", _detail)
                                                                                        // const listPayMethods = _detail?.status === "Pendiente"
                                                                                        //     ? (_user?.pay_methods_pending ?? [])
                                                                                        //     : (_detail?.pay_methods ?? []);


                                                                                        console.log("CORTE ACTUAL:", _detail);

                                                                                        const cashCutDetail = (_user?.cashCut ?? []).find(
                                                                                            (cut) => cut.id_cash === _detail?.id_cash
                                                                                        );

                                                                                        const listPayMethods = _detail?.status === "Pendiente"
                                                                                            ? (_user?.pay_methods_pending ?? [])
                                                                                            : (cashCutDetail?.pay_methods ?? []);


                                                                                        const rowKey = `${_user?.id_user}-${_branch?.id_branch}-${_key_detail}`;
                                                                                        return (
                                                                                            <React.Fragment key={`${_key_user}-${_key_detail}`}>
                                                                                                <tr style={{
                                                                                                    backgroundColor: isSelected
                                                                                                        ? '#b3d9ff'
                                                                                                        : (_detail?.user_modified_amount !== null && _detail?.user_modified_amount !== undefined && _detail?.user_modified_amount !== "")
                                                                                                            ? '#fff3cd'
                                                                                                            : _detail?.is_extemporaneous
                                                                                                                ? '#0029405e'
                                                                                                                : ''
                                                                                                }} >
                                                                                                    <td style={{
                                                                                                        width: "90px",
                                                                                                        padding: "4px",
                                                                                                        textAlign: "center",
                                                                                                        whiteSpace: "nowrap"
                                                                                                    }}>
                                                                                                        {
                                                                                                            _user?.historicChange?.length > 0 && (
                                                                                                                <button
                                                                                                                    title="Este usuario tiene cambios históricos"
                                                                                                                    className="historic-button"
                                                                                                                    onClick={() => openEvidence(_user?.historicChange)}
                                                                                                                >
                                                                                                                    <i className="fa fa-exclamation-triangle"></i>
                                                                                                                </button>
                                                                                                            )
                                                                                                        }


                                                                                                        {
                                                                                                            _admin_cash === "True" &&
                                                                                                            _detail?.status === "Pendiente" &&
                                                                                                            (
                                                                                                                <button title='Generar corte extemporaneo' class="cash-button" onClick={() => showModalTicket(_user ?? [], _key_detail)} ><i style={{ fontSize: "11px" }} className="fa fa-pencil-square-o"></i></button>

                                                                                                            )
                                                                                                        }


                                                                                                        <button
                                                                                                            title={
                                                                                                                expandedRows2[rowKey]
                                                                                                                    ? "Cerrar detallado"
                                                                                                                    : "Detallado del corte"
                                                                                                            }
                                                                                                            className={
                                                                                                                expandedRows2[rowKey]
                                                                                                                    ? "expand-button2 action-mini"
                                                                                                                    : "expands-button action-mini"
                                                                                                            }
                                                                                                            onClick={() => toggleRow2(rowKey)}
                                                                                                        >
                                                                                                            {expandedRows2[rowKey] ? "-" : "+"}
                                                                                                        </button>

                                                                                                        {
                                                                                                            // * BUTTON TO DOWNLOAD PDF OR EXCEL REPORTS
                                                                                                        }
                                                                                                        {
                                                                                                            _detail?.status !== "Pendiente" &&
                                                                                                            _admin_cash === "True" &&
                                                                                                            _detail?.fechCashFlow &&
                                                                                                            isWithin24Hours(_detail?.fechCashFlow) &&
                                                                                                            (
                                                                                                                <button
                                                                                                                    title="Modificar Corte"
                                                                                                                    className="pdf-button0 action-mini"
                                                                                                                    onClick={() =>
                                                                                                                        showModalModifiedAmount(
                                                                                                                            _user ?? [],
                                                                                                                            _key_detail
                                                                                                                        )
                                                                                                                    }
                                                                                                                >
                                                                                                                    <i className="fa fa-pencil ml-1"></i>
                                                                                                                </button>
                                                                                                            )
                                                                                                        }


                                                                                                        {
                                                                                                            _detail?.status !== "Pendiente" &&
                                                                                                            _detail?.fechCashFlow &&
                                                                                                            (
                                                                                                                <>
                                                                                                                    {
                                                                                                                        loadingPrintKey === rowKey
                                                                                                                            ? (

                                                                                                                                <i title="Generando PDF..." className="fa fa-spinner f-20 txt-danger fa-spin"></i>
                                                                                                                            )
                                                                                                                            : (
                                                                                                                                <button
                                                                                                                                    title="Descargar corte"
                                                                                                                                    className="pdf-button action-mini"
                                                                                                                                    // onClick={() =>
                                                                                                                                    //     printTicket2(
                                                                                                                                    //         _detail?.id_cash,
                                                                                                                                    //         0,
                                                                                                                                    //         _detail?.is_extemporaneous === true,
                                                                                                                                    //         _user ?? [],
                                                                                                                                    //         _key_detail,
                                                                                                                                    //         rowKey
                                                                                                                                    //     )
                                                                                                                                    // }
                                                                                                                                    onClick={() =>
                                                                                                                                        printTicket2(
                                                                                                                                            _detail?.id_cash,
                                                                                                                                            0,
                                                                                                                                            _detail?.is_extemporaneous === true,
                                                                                                                                            _user ?? [],
                                                                                                                                            _key_detail,
                                                                                                                                            rowKey,
                                                                                                                                            listPayMethods // 👈 Enviar los métodos del corte actual
                                                                                                                                        )
                                                                                                                                    }
                                                                                                                                >
                                                                                                                                    <i className="fa fa-file-text-o"></i>

                                                                                                                                </button>
                                                                                                                            )
                                                                                                                    }

                                                                                                                    {
                                                                                                                        urlHelen === "https://cedimi.helen-sw.com" &&
                                                                                                                        <button
                                                                                                                            title="Descargar reporte contado"
                                                                                                                            className="others-button action-mini"
                                                                                                                            onClick={() => downloadExcelOthers(_detail?.id_cash, 0)}
                                                                                                                        >
                                                                                                                            <i className="fa fa-users"></i>
                                                                                                                        </button>
                                                                                                                    }


                                                                                                                    {
                                                                                                                        urlHelen === "https://cedimi.helen-sw.com" &&
                                                                                                                        <button
                                                                                                                            title="Descargar reporte credito"
                                                                                                                            className="credit-button action-mini"
                                                                                                                            onClick={() => downloadExcelCredits(_detail?.id_cash, 0)}
                                                                                                                        >
                                                                                                                            <i className="fa fa-credit-card"></i>
                                                                                                                        </button>
                                                                                                                    }
                                                                                                                </>
                                                                                                            )
                                                                                                        }

                                                                                                    </td>
                                                                                                    <td>{_detail?.user_capture}</td>
                                                                                                    <td style={{ fontWeight: "bold", textAlign: "end" }}>
                                                                                                        {
                                                                                                            _detail?.status === "Pendiente"
                                                                                                                ? listPayMethods?.length > 0
                                                                                                                    ? (
                                                                                                                        listPayMethods.reduce((acc, _amount) => {
                                                                                                                            if (_amount?.id_pay_method === 1) {
                                                                                                                                totalBranchAmount += Number(_amount?.amount ?? 0);

                                                                                                                                acc = (
                                                                                                                                    <label
                                                                                                                                        style={{ fontSize: "10px" }}
                                                                                                                                        className="f-w-600"
                                                                                                                                    >
                                                                                                                                        {formatter.format(_amount?.amount ?? 0)}
                                                                                                                                    </label>
                                                                                                                                );
                                                                                                                            }

                                                                                                                            return acc;
                                                                                                                        }, (
                                                                                                                            <label
                                                                                                                                style={{ fontSize: "10px" }}
                                                                                                                                className="f-w-600"
                                                                                                                            >
                                                                                                                                {formatter.format(0)}
                                                                                                                            </label>
                                                                                                                        ))
                                                                                                                    )
                                                                                                                    : (
                                                                                                                        <label
                                                                                                                            style={{ fontSize: "10px" }}
                                                                                                                            className="f-w-600"
                                                                                                                        >
                                                                                                                            {formatter.format(0)}
                                                                                                                        </label>
                                                                                                                    )
                                                                                                                : (
                                                                                                                    <label
                                                                                                                        style={{ fontSize: "10px" }}
                                                                                                                        className="f-w-600"
                                                                                                                    >
                                                                                                                        {formatter.format(_detail?.amount ?? 0)}
                                                                                                                    </label>
                                                                                                                )
                                                                                                        }
                                                                                                    </td>
                                                                                                    {/* <td style={{ fontWeight: "bold", textAlign: "end" }}>
                                                                                                        {
                                                                                                            _detail.status === "Pendiente" ?

                                                                                                                _user?.pay_methods?.length > 0 ? (
                                                                                                                    _user?.pay_methods.reduce((acc, _amount) => {
                                                                                                                        if (_amount?.id_pay_method === 1) {
                                                                                                                            totalBranchAmount += _amount?.amount
                                                                                                                            acc = <label style={{ fontSize: "10px" }} className='f-w-600'>{formatter.format(_amount?.amount) ?? 0}</label>;
                                                                                                                        }
                                                                                                                        return acc;
                                                                                                                    }, null || (
                                                                                                                        <label style={{ fontSize: "10px" }} className='f-w-600'>{formatter.format(0)}</label>
                                                                                                                    )
                                                                                                                    )
                                                                                                                ) : <label style={{ fontSize: "10px" }} className='f-w-600'>{formatter.format(0)}</label>

                                                                                                                :
                                                                                                                _user?.cash.length > 0 &&

                                                                                                                <label style={{ fontSize: "10px" }} className='f-w-600'>{formatter.format(_detail?.amount)}</label>

                                                                                                        }
                                                                                                    </td> */}
                                                                                                    <td
                                                                                                        style={{
                                                                                                            fontWeight: "bold",
                                                                                                            textAlign: "end",
                                                                                                            whiteSpace: "nowrap"
                                                                                                        }}
                                                                                                    >
                                                                                                        {
                                                                                                            //_detail?.user_modified_amount !== null && _detail?.user_modified_amount !== undefined && _detail?.user_modified_amount !== "")
                                                                                                            (_detail?.user_modified_amount !== null && _detail?.user_modified_amount !== undefined && _detail?.user_modified_amount !== "") ? (
                                                                                                                <>
                                                                                                                    o                                                    <span>
                                                                                                                        {formatter.format(_detail?.modified_amount)}
                                                                                                                    </span>

                                                                                                                    <i
                                                                                                                        id={`btn-tooltip-modified-${_user?.id_user}-${_branch?.id_branch}-${_key_detail}`}
                                                                                                                        className="fa fa-exclamation-triangle ml-2"
                                                                                                                        style={{
                                                                                                                            color: "#f0ad4e",
                                                                                                                            cursor: "pointer",
                                                                                                                            fontSize: "14px"
                                                                                                                        }}
                                                                                                                    ></i>

                                                                                                                    <ToolTips
                                                                                                                        placement="top"
                                                                                                                        dataTarget={`btn-tooltip-modified-${_user?.id_user}-${_branch?.id_branch}-${_key_detail}`}
                                                                                                                        dataText={
                                                                                                                            <>
                                                                                                                                <strong>Ajuste de monto</strong>

                                                                                                                                <br />
                                                                                                                                <br />

                                                                                                                                <strong>Usuario que capturó originalmente:</strong>
                                                                                                                                <br />
                                                                                                                                {_detail?.user_capture ?? "------"}

                                                                                                                                <br />
                                                                                                                                <br />

                                                                                                                                <strong>Monto anterior:</strong>
                                                                                                                                <br />
                                                                                                                                {formatter.format(_detail?.captureAmount ?? 0)}

                                                                                                                                <br />
                                                                                                                                <br />

                                                                                                                                <strong>Usuario que realizó el ajuste:</strong>
                                                                                                                                <br />
                                                                                                                                {_detail?.user_modified_amount ?? "------"}

                                                                                                                                <br />
                                                                                                                                <br />

                                                                                                                                <strong>Nuevo monto:</strong>
                                                                                                                                <br />
                                                                                                                                {formatter.format(_detail?.modified_amount ?? 0)}

                                                                                                                                {
                                                                                                                                    _detail?.modification_date && (
                                                                                                                                        <>
                                                                                                                                            <br />
                                                                                                                                            <br />

                                                                                                                                            <strong>Fecha de modificación:</strong>
                                                                                                                                            <br />
                                                                                                                                            {_detail?.modification_date}
                                                                                                                                        </>
                                                                                                                                    )
                                                                                                                                }
                                                                                                                            </>
                                                                                                                        }
                                                                                                                    />
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                formatter.format(_detail?.captureAmount ?? 0)
                                                                                                            )
                                                                                                        }
                                                                                                    </td>
                                                                                                    {/* <td style={{ fontWeight: "bold", textAlign: "end" }}>{formatter.format(_detail.modified_amount === 0 ? _detail?.captureAmount : _detail?.modified_amount)}</td> */}
                                                                                                    <td style={{ fontWeight: "bold", textAlign: "center" }}>
                                                                                                        {
                                                                                                            difference === 0
                                                                                                                ? (
                                                                                                                    <i
                                                                                                                        className="fa fa-times-circle"
                                                                                                                        style={{
                                                                                                                            color: "#dc3545",
                                                                                                                            fontSize: "20px"
                                                                                                                        }}
                                                                                                                        title="Sin diferencia"
                                                                                                                    />
                                                                                                                )
                                                                                                                : formatter.format(difference)
                                                                                                        }
                                                                                                    </td>
                                                                                                    <td style={{ textAlign: "center" }}>{_detail?.status === "Pendiente" ? "N/A" : _detail?.is_extemporaneous ? _detail?.fechExtemporaneous : _detail?.fechCashFlow}</td>
                                                                                                    <td style={{ textAlign: "center" }}>
                                                                                                        <div
                                                                                                            style={{
                                                                                                                display: "inline-flex",
                                                                                                                alignItems: "center",
                                                                                                                justifyContent: "center",
                                                                                                                width: "110px",
                                                                                                                height: "30px",
                                                                                                                borderRadius: "30px",
                                                                                                                fontSize: "11px",
                                                                                                                fontWeight: "700",
                                                                                                                color: "#fff",
                                                                                                                whiteSpace: "nowrap",
                                                                                                                overflow: "hidden",
                                                                                                                background:
                                                                                                                    _detail?.status === "Pendiente"
                                                                                                                        ? "linear-gradient(135deg, #9E9E9E, #757575)"
                                                                                                                        : "linear-gradient(135deg, #51bb25, #51bb25)",
                                                                                                                boxShadow: "0px 3px 8px rgba(0,0,0,.15)"
                                                                                                            }}
                                                                                                        >
                                                                                                            <i
                                                                                                                className={
                                                                                                                    _detail?.status === "Pendiente"
                                                                                                                        ? "fa fa-clock-o"
                                                                                                                        : "fa fa-check-circle"
                                                                                                                }
                                                                                                                style={{ marginRight: "6px" }}
                                                                                                            />

                                                                                                            {_detail?.status}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td className={_detail?.status === "Pendiente" ? "d-none" : ""} style={{ textAlign: "center" }}>
                                                                                                        {
                                                                                                            _detail?.validate_cash_flow === "" ?
                                                                                                                <>
                                                                                                                    <input
                                                                                                                        type="checkbox"
                                                                                                                        checked={selectedKey === `${_user?.id_user}-${_branch?.id_branch}-${_key_detail}`}
                                                                                                                        onChange={() => handleSearchAuthorization(_user?.id_user, _branch?.id_branch, _key_detail, _user?.pay_methods, _detail?.user_capture, _detail?.id_cash, _user ?? [], _key_detail)}
                                                                                                                        style={{ display: 'none' }}
                                                                                                                    />
                                                                                                                    <label
                                                                                                                        style={{
                                                                                                                            display: 'inline-block',
                                                                                                                            width: '20px',
                                                                                                                            height: '20px',
                                                                                                                            borderRadius: '50%',
                                                                                                                            border: '2px solid #065c88',
                                                                                                                            backgroundColor: 'transparent',
                                                                                                                            cursor: 'pointer',
                                                                                                                            position: 'relative',
                                                                                                                            opacity: 0.6
                                                                                                                        }}
                                                                                                                        onClick={() => handleSearchAuthorization(_user?.id_user, _branch?.id_branch, _key_detail, _user?.pay_methods, _detail?.user_capture, _detail?.id_cash, _user ?? [], _key_detail)}
                                                                                                                    >
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                position: 'absolute',
                                                                                                                                top: '50%',
                                                                                                                                left: '50%',
                                                                                                                                width: '12px',
                                                                                                                                height: '12px',
                                                                                                                                backgroundColor: '#065c88',
                                                                                                                                borderRadius: '50%',
                                                                                                                                transform: 'translate(-50%, -50%)',
                                                                                                                                opacity: selectedKey === `${_user?.id_user}-${_branch?.id_branch}-${_key_detail}` ? 1 : 0,
                                                                                                                                transition: 'opacity 0.2s',
                                                                                                                            }}
                                                                                                                        ></span>
                                                                                                                    </label>
                                                                                                                </>
                                                                                                                :
                                                                                                                <Col
                                                                                                                    id={`btn-tooltip${_user?.id_user}-${_branch?.id_branch}-${_key_detail}`}
                                                                                                                    sm="12"
                                                                                                                    style={{
                                                                                                                        display: "inline-flex",
                                                                                                                        alignItems: "center",
                                                                                                                        justifyContent: "center",
                                                                                                                        width: "110px",
                                                                                                                        height: "30px",
                                                                                                                        borderRadius: "30px",
                                                                                                                        fontSize: "11px",
                                                                                                                        fontWeight: "700",
                                                                                                                        color: "#fff",
                                                                                                                        background: "linear-gradient(135deg, #43A047, #2E7D32)",
                                                                                                                        boxShadow: "0px 3px 8px rgba(0,0,0,.15)",
                                                                                                                        whiteSpace: "nowrap",
                                                                                                                        margin: "0 auto",
                                                                                                                        padding: "0"
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i
                                                                                                                        className="fa fa-check-circle"
                                                                                                                        style={{ marginRight: "6px" }}
                                                                                                                    />

                                                                                                                    {_detail?.validate_cash_flow}

                                                                                                                    <ToolTips
                                                                                                                        placement="top"
                                                                                                                        dataTarget={`btn-tooltip${_user?.id_user}-${_branch?.id_branch}-${_key_detail}`}
                                                                                                                        dataText={
                                                                                                                            <>
                                                                                                                                <img
                                                                                                                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                                                                                    alt="icon"
                                                                                                                                    width="100"
                                                                                                                                    height="100"
                                                                                                                                />
                                                                                                                                <br />
                                                                                                                                <strong>Responsable:</strong>
                                                                                                                                <br />
                                                                                                                                {_detail?.authorization_user ?? "------"}

                                                                                                                                <br />
                                                                                                                                <br />

                                                                                                                                <strong>Fecha de autorización:</strong>
                                                                                                                                <br />
                                                                                                                                {_detail?.authorization_date ?? "-----"}
                                                                                                                            </>
                                                                                                                        }
                                                                                                                    />
                                                                                                                </Col>

                                                                                                        }

                                                                                                    </td>
                                                                                                </tr>
                                                                                                {expandedRows2[rowKey] && (
                                                                                                    <tr
                                                                                                        style={{
                                                                                                            background: "#fff",
                                                                                                            borderRadius: "12px",
                                                                                                            boxShadow: "0 8px 25px rgba(0,0,0,.12)",
                                                                                                            padding: "18px",
                                                                                                            border: "1px solid #e9ecef"
                                                                                                        }}
                                                                                                    >
                                                                                                        <td colSpan="5"></td>
                                                                                                        <td colSpan="3">
                                                                                                            <Table striped size="lg" style={{ fontSize: '12px' }}>
                                                                                                                <thead>
                                                                                                                    <tr>
                                                                                                                        <th
                                                                                                                            style={{
                                                                                                                                backgroundColor: "#002940",
                                                                                                                                color: "#fff",
                                                                                                                                fontWeight: "bold",
                                                                                                                                padding: '10px 10px',
                                                                                                                                textAlign: 'center'
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            Métodos de Pagos Registrados
                                                                                                                        </th>
                                                                                                                        <th
                                                                                                                            style={{
                                                                                                                                backgroundColor: "#002940",
                                                                                                                                color: "#fff",
                                                                                                                                fontWeight: "bold",
                                                                                                                                padding: '10px 10px',
                                                                                                                                textAlign: 'center'
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            Montos
                                                                                                                        </th>
                                                                                                                    </tr>
                                                                                                                </thead>
                                                                                                                <tbody>
                                                                                                                    {(listPayMethods ?? []).map((_pay, _k) => {

                                                                                                                        const payMethod = listPayMethod?.find(
                                                                                                                            x => x.id_pay_method === _pay?.id_pay_method
                                                                                                                        );

                                                                                                                        const payMethodLabel = payMethod?.name ?? "Desconocido";

                                                                                                                        return (
                                                                                                                            <tr key={_k} style={{ height: "40px" }}>
                                                                                                                                <td
                                                                                                                                    style={{
                                                                                                                                        padding: "15px 25px",
                                                                                                                                        textAlign: "center"
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {payMethodLabel}
                                                                                                                                </td>

                                                                                                                                <td
                                                                                                                                    className="f-w-600"
                                                                                                                                    style={{
                                                                                                                                        padding: "15px 25px",
                                                                                                                                        textAlign: "center"
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {formatter.format(Number(_pay?.amount) || 0)}
                                                                                                                                </td>
                                                                                                                            </tr>
                                                                                                                        );
                                                                                                                    })}
                                                                                                                </tbody>
                                                                                                                <tr>
                                                                                                                    <td
                                                                                                                        style={{
                                                                                                                            backgroundColor: '#000',
                                                                                                                            color: "#fff",
                                                                                                                            textAlign: "end",
                                                                                                                            fontWeight: "bold",
                                                                                                                            padding: '10px 20px',
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {"Total"}
                                                                                                                    </td>
                                                                                                                    <td
                                                                                                                        style={{
                                                                                                                            backgroundColor: '#000',
                                                                                                                            color: "#fff",
                                                                                                                            fontWeight: "bold",
                                                                                                                            padding: '10px 20px',
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {/* {formatter.format(
                                                                                                                            (listPayMethods ?? []).reduce(
                                                                                                                                (total, item) => total + (Number(item?.amount) || 0),
                                                                                                                                0
                                                                                                                            )
                                                                                                                        )} */}
                                                                                                                        {formatter.format(
                                                                                                                            (listPayMethods ?? []).reduce(
                                                                                                                                (total, item) => total + (Number(item?.amount) || 0),
                                                                                                                                0
                                                                                                                            )
                                                                                                                        )}
                                                                                                                        {/* {formatter.format(_sum)} */}
                                                                                                                    </td>
                                                                                                                </tr>
                                                                                                            </Table>
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                )}
                                                                                            </React.Fragment>
                                                                                        );
                                                                                    })
                                                                                ))}
                                                                                <tr>
                                                                                    <td></td>
                                                                                    <td style={{ textAlign: "end", fontWeight: "bold" }}>Total</td>
                                                                                    <td style={{ backgroundColor: '#1f4e69', color: "#fff", textAlign: "end", fontWeight: "bold" }}>
                                                                                        {formatter.format((Number(totalBranchAmount) || 0) + (Number(totalBranchAmount2) || 0))}
                                                                                    </td>
                                                                                    <td style={{ backgroundColor: '#1f4e69', color: "#fff", textAlign: "end", fontWeight: "bold" }}>
                                                                                        {formatter.format(totalBranchCaptureAmount)}
                                                                                    </td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </tbody>
                                            {totalAmountCash}
                                        </Table>
                                    </div>
                                </Col>
                            </Row>
                        </Col>




                    </Card>
                </div>
            </div>
            <ModalAuthorizationCash
                {
                ...{
                    toogleAuthorization, modalAuthorization, _commercialLine, _nameUser,
                    _branchName, _new, handleOpenPreview, handleClosedPreview, viewDetail, viewAmount,
                    formatter, user, _admin_cash, id_cash, saveCourtesyPatient,
                    listPayMethod, showMovementDialog
                }
                }

            />
            {
                // ? DIALOG 
            }
            <Dialog
                visible={visibleTicket}
                style={{ width: '70vw' }}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">
                            <div className="Global-dialog-icon">
                                <i className="pi pi-money-bill"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Corte Extemporaneo

                                </div>
                            </div>
                        </div>
                    </div>
                }
                className="Global-dialog Global-blue Global-medium3"
                maskClassName="custom-total-mask"
                position={showMovementDialog ? "left" : "center"}

                closable={false}
                onHide={hideModalTicket}
                footer={footerContent}>
                <Col sm="12" className='pl-0 pr-0' >
                    {
                        loadingExtemporaneous &&
                        <>
                            <Row>
                                <Col sm="12" md="12" lg="12" className='text-center'>
                                    <img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "10%" }} />
                                </Col>
                                <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                    <p className='txt-secondary f-w-600 f-16' > Generando corte extemporaneo ...</p>
                                </Col>
                            </Row>
                        </>
                    }

                    <div className={loadingExtemporaneous ? "d-none" : "cash-authorization-content"}  >
                        <div className="cash-authorization-company-card">
                            <div className="cash-authorization-company-icon">
                                <i className="fa fa-building-o"></i>
                            </div>

                            <div className="cash-authorization-company-information">
                                <span className="cash-authorization-section-label">
                                    REVISIÓN DE CORTE EXTEMPORANEO
                                </span>

                                <h5 className="cash-authorization-company-name">
                                    {_commercialLine ?? "Sin línea comercial"}
                                </h5>

                                <span className="cash-authorization-branch-name">
                                    {_branchName ?? "Sin sucursal"}
                                </span>
                            </div>

                            <div className="cash-authorization-company-logo">
                                <img
                                    src={
                                        ConfigServer.serverUrl +
                                        "/api/Configuration/Logo"
                                    }
                                    alt="Logo"
                                />
                            </div>
                        </div>
                        {
                            // ? DETAIL TICKET
                        }
                        <div className="cash-authorization-authorization-card">
                            <div className="cash-authorization-authorization-header">
                                <div className="cash-authorization-authorization-icon2">
                                    <i className="fa fa-file-text-o"></i>
                                </div>

                                <div>
                                    <h6 className="cash-authorization-authorization-title">
                                        Información del responsable de realizar el movimiento
                                    </h6>

                                    <span className="cash-authorization-authorization-subtitle">
                                        Datos del usuario asi como sucursal
                                    </span>
                                </div>
                            </div>

                            <div className="cash-authorization-information-item">

                                <div className="cash-authorization-information-number2">
                                    1
                                </div>

                                <div className="cash-authorization-information-content">
                                    <span className="cash-authorization-information-title">
                                        Fecha y hora de autorización
                                    </span>

                                    <span className="cash-authorization-information-value">
                                        {
                                            infoTicket?.pay_methods?.[
                                                infoTicket?.pay_methods?.length - 1
                                            ]?.created_at ?? "---"
                                        }
                                    </span>
                                </div>

                            </div>

                            <div className="cash-authorization-information-item">

                                <div className="cash-authorization-information-number2">
                                    2
                                </div>

                                <div className="cash-authorization-information-content">
                                    <span className="cash-authorization-information-title">
                                        Responsable
                                    </span>

                                    <span className="cash-authorization-information-value">
                                        {_nameUser ?? "-----"}
                                    </span>
                                </div>

                            </div>


                            <div className="cash-authorization-information-item">

                                <div className="cash-authorization-information-number2">
                                    3
                                </div>

                                <div className="cash-authorization-information-content">
                                    <span className="cash-authorization-information-title">
                                        Sucursal
                                    </span>

                                    <span className="cash-authorization-information-value">
                                        {branchs ?? "-----"}
                                    </span>
                                </div>

                            </div>
                        </div>
                        {
                            // ? BODY TICKET
                        }
                        <div className="cash-authorization-detail-grid">
                            <div className="cash-authorization-card">
                                <div className="cash-authorization-card-header">
                                    <div className="cash-authorization-card-header-icon cash-authorization-card-header-icon-blue2">
                                        <i className="fa fa-user"></i>
                                    </div>

                                    <div>
                                        <h6 className="cash-authorization-card-title">
                                            Usuario de caja abierta
                                        </h6>

                                        <span className="cash-authorization-card-subtitle">
                                            Usuario que no registro su corte
                                        </span>
                                    </div>
                                </div>

                                <div className="cash-authorization-user">
                                    <div className="cash-authorization-user-avatar">
                                        <Media
                                            src={require("../../assets/images/loginHelenLabs/User/UserWoman.svg")}
                                            alt="Responsable del corte"
                                        />
                                    </div>

                                    <div className="cash-authorization-user-information">
                                        <div className="cash-authorization-user-detail">
                                            <span className="cash-authorization-user-name">
                                                {userCapture ?? "Usuario no disponible"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="cash-authorization-user-status2">
                                        <i className="fa fa-check-circle"></i>
                                        Pendiente
                                    </div>
                                </div>
                            </div>

                            {
                                // * PAYMENT
                            }
                            <div className="cash-authorization-card">
                                <div className="cash-authorization-card-header">
                                    <div className="cash-authorization-card-header-icon cash-authorization-card-header-icon-green">
                                        <i className="fa fa-credit-card"></i>
                                    </div>

                                    <div>
                                        <h6 className="cash-authorization-card-title">
                                            Métodos de pago
                                        </h6>

                                        <span className="cash-authorization-card-subtitle">
                                            Importes registrados en el corte
                                        </span>
                                    </div>

                                    <span className="cash-authorization-level cash-authorization-level-green">
                                        {infoTicket?.pay_methods?.length ?? 0} métodos
                                    </span>
                                </div>

                                <div className="cash-authorization-payment-list">
                                    {infoTicket?.pay_methods?.length > 0 ? (
                                        infoTicket.pay_methods.map((_pay, _k) => {

                                            const payMethod = listPayMethod?.find(
                                                x => x.id_pay_method === _pay?.id_pay_method
                                            );

                                            const payMethodLabel = payMethod?.name ?? "Desconocido";

                                            let payMethodIcon = "fa-calendar-check-o";

                                            switch (_pay?.id_pay_method) {
                                                case 1:
                                                    payMethodIcon = "fa-money";
                                                    break;

                                                case 2:
                                                    payMethodIcon = "fa-credit-card";
                                                    break;

                                                case 4:
                                                    payMethodIcon = "fa-credit-card-alt";
                                                    break;

                                                case 7:
                                                    payMethodIcon = "fa-money";
                                                    break;

                                                case 8:
                                                    payMethodIcon = "fa-exchange";
                                                    break;

                                                case 10:
                                                    payMethodIcon = "fa-calendar-check-o";
                                                    break;

                                                case 30:
                                                    payMethodIcon = "fa-ticket";
                                                    break;

                                                default:
                                                    payMethodIcon = "fa-question-circle";
                                                    break;
                                            }

                                            return (
                                                <div
                                                    className="cash-authorization-payment-item"
                                                    key={`${_pay?.id_pay_method}-${_k}`}
                                                >
                                                    <div className="cash-authorization-payment-information">
                                                        <span className="cash-authorization-payment-icon">
                                                            <i className={`fa ${payMethodIcon}`}></i>
                                                        </span>

                                                        <span className="cash-authorization-payment-name">
                                                            {payMethodLabel}
                                                        </span>
                                                    </div>

                                                    <span className="cash-authorization-payment-amount">
                                                        {formatter.format(Number(_pay?.amount ?? 0))}
                                                    </span>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="cash-authorization-empty">
                                            <i className="fa fa-info-circle"></i>
                                            No existen métodos de pago registrados.
                                        </div>
                                    )}
                                </div>


                                <div className="cash-authorization-total">
                                    <div className="cash-authorization-total-information">
                                        <span className="cash-authorization-total-label">
                                            Total de efectivo registrado:  <strong>
                                                {formatter.format(
                                                    Number(formextemporaneus?.amount ?? 0)
                                                )}
                                            </strong>
                                        </span>
                                        <span className="cash-authorization-total-description">
                                            Suma de todos los métodos de pago
                                        </span>
                                    </div>

                                    <span className="cash-authorization-total-amount">
                                        {formatter.format(
                                            infoTicket?.pay_methods?.reduce(

                                                (total, item) =>
                                                    total + Number(item?.amount ?? 0),
                                                0
                                            ) ?? 0
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {
                            // ?  AMOUNT TO BE REPORTED
                        }
                        <div className="cash-authorization-authorization-card">
                            <div className="cash-authorization-authorization-header">
                                <div className="cash-authorization-authorization-icon">
                                    <i className="fa fa-check-square-o"></i>
                                </div>

                                <div>
                                    <h6 className="cash-authorization-authorization-title">
                                        Monto a reportar en caja
                                    </h6>

                                    <span className="cash-authorization-authorization-subtitle">
                                        Datos de los moviemientos registrados
                                    </span>
                                </div>
                            </div>

                            <div className="cash-authorization-authorization-grid">

                                <div className="cash-authorization-information-item">
                                    <div className="cash-authorization-information-number">
                                        1
                                    </div>

                                    <div className="cash-authorization-information-content">
                                        <span className="cash-authorization-information-label">
                                            Monto en efectivo a reportar
                                        </span>


                                        <span className="cash-authorization-information-label">
                                            <input value={formextemporaneus.amount} onChange={handleAmount} type="number" className='inputCash f-12' placeholder='Ingrese la cantidad' name="capture_amount" />
                                        </span>
                                    </div>
                                </div>
                                <div className="cash-authorization-information-item pr-0">
                                    <div className="cash-authorization-information-number cash-authorization-information-number-green">
                                        2
                                    </div>

                                    <div className="cash-authorization-information-content">
                                        <span className="cash-authorization-information-label">
                                            Comentario adjunto al recibo de corte de caja
                                        </span>
                                        <textarea
                                            className='form-control form-control-sm input-air-primary'
                                            name="comments"
                                            rows="3"
                                            value={formextemporaneus.comment}
                                            onChange={handleComment}
                                            style={{ fontSize: "12px" }}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            // ? VIEW    TICKET
                        }
                        <div className="cash-authorization-alert">
                            <div className="cash-authorization-alert-icon">
                                <i className="fa fa-exclamation-triangle"></i>
                            </div>

                            <div className="cash-authorization-alert-content">
                                <span className="cash-authorization-alert-title">
                                    Visualización del pdf
                                </span>

                                <span className="cash-authorization-alert-description">
                                    Verifica la información sea la correcta
                                    antes de generar el corte.
                                </span>
                            </div>

                            <button
                                type="button"
                                className="cash-authorization-detail-button"
                                onClick={() => setShowMovementDialog(true)}
                            >
                                <i className="fa fa-eye"></i>
                                Visualizar movimientos
                            </button>
                        </div>


                    </div>
                </Col>
            </Dialog>

            {

            }
            <Dialog
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">
                            <div className="Global-dialog-icon">
                                <i className="pi pi-money-bill"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Modificación de metódo de pago

                                </div>
                            </div>
                        </div>
                    </div>
                }
                className="Global-dialog Global-blue Global-medium2"
                maskClassName="custom-total-mask"
                visible={showEvidence}
                onHide={() => setShowEvidence(false)}
            >
                {historicChanges.map((item, index) => (
                    <div key={index} className="change-historic-card">

                        <div className="change-historic-card-header">

                            <div className="change-historic-header-left">
                                <div className="change-historic-header-icon">
                                    <i className="fa fa-pencil"></i>
                                </div>

                                <div className="change-historic-header-text">
                                    <span className="change-historic-header-title">
                                        Modificación registrada
                                    </span>

                                    <span className="change-historic-header-subtitle">
                                        Detalle del cambio realizado
                                    </span>
                                </div>
                            </div>

                            <span className="change-historic-status-badge">
                                Cambio #{index + 1}
                            </span>

                        </div>

                        <div className="change-historic-card-body">

                            <div className="change-historic-summary">

                                <div className="change-historic-summary-item">
                                    <div className="change-historic-summary-icon">
                                        <i className="pi pi-user"></i>
                                    </div>

                                    <div className="change-historic-summary-content">
                                        <span className="change-historic-summary-label">
                                            Usuario responsable
                                        </span>

                                        <span className="change-historic-summary-value">
                                            {item.name_user || "Usuario no disponible"}
                                        </span>
                                    </div>
                                </div>

                                <div className="change-historic-summary-item">
                                    <div className="change-historic-summary-icon">
                                        <i className="pi pi-map-marker"></i>
                                    </div>

                                    <div className="change-historic-summary-content">
                                        <span className="change-historic-summary-label">
                                            Lugar
                                        </span>

                                        <span className="change-historic-summary-value">
                                            {item.site || "Sucursal no disponible"}
                                        </span>
                                    </div>
                                </div>

                                <div className="change-historic-summary-item">
                                    <div className="change-historic-summary-icon">
                                        <i className="pi pi-calendar"></i>
                                    </div>

                                    <div className="change-historic-summary-content">
                                        <span className="change-historic-summary-label">
                                            Fecha de modificación
                                        </span>

                                        <span className="change-historic-summary-value">
                                            {item.created_information || "Fecha no disponible"}
                                        </span>
                                    </div>
                                </div>

                            </div>

                            <div className="change-historic-alert">
                                <div className="change-historic-alert-icon">
                                    <i className="pi pi-info-circle"></i>
                                </div>

                                <div className="change-historic-alert-content">
                                    <span className="change-historic-alert-title">
                                        Comparación de información
                                    </span>

                                    <span className="change-historic-alert-description">
                                        Revisa los valores anteriores y los valores actualizados.
                                    </span>
                                </div>
                            </div>

                            <div className="change-historic-comparison">

                                <div className="change-historic-information-card change-historic-information-old">

                                    <div className="change-historic-information-header">
                                        <div className="change-historic-information-header-left">
                                            <div className="change-historic-information-icon">
                                                <i className="pi pi-history"></i>
                                            </div>

                                            <div>
                                                <span className="change-historic-information-title">
                                                    Información anterior
                                                </span>

                                                <span className="change-historic-information-subtitle">
                                                    Valor registrado previamente
                                                </span>
                                            </div>
                                        </div>

                                        <span className="change-historic-information-badge change-historic-information-badge-old">
                                            Anterior
                                        </span>
                                    </div>

                                    <div className="change-historic-information-body">
                                        {item.original_information || "Sin información anterior"}
                                    </div>

                                </div>

                                <div className="change-historic-information-card change-historic-information-new">

                                    <div className="change-historic-information-header">
                                        <div className="change-historic-information-header-left">
                                            <div className="change-historic-information-icon change-historic-information-icon-new">
                                                <i className="pi pi-check-circle"></i>
                                            </div>

                                            <div>
                                                <span className="change-historic-information-title">
                                                    Información actual
                                                </span>

                                                <span className="change-historic-information-subtitle">
                                                    Nuevo valor registrado
                                                </span>
                                            </div>
                                        </div>

                                        <span className="change-historic-information-badge change-historic-information-badge-new">
                                            Actual
                                        </span>
                                    </div>

                                    <div className="change-historic-information-body">
                                        {item.updated_information || "Sin información actual"}
                                    </div>

                                </div>

                            </div>

                            {item.observation && (
                                <div className="change-historic-observation">

                                    <div className="change-historic-observation-header">
                                        <div className="change-historic-observation-icon">
                                            <i className="fa fa-commenting-o"></i>
                                        </div>

                                        <div>
                                            <span className="change-historic-observation-title">
                                                Observaciones
                                            </span>

                                            <span className="change-historic-observation-subtitle">
                                                Comentario relacionado con el cambio
                                            </span>
                                        </div>
                                    </div>

                                    <div className="change-historic-observation-body">
                                        {item.observation}
                                    </div>

                                </div>
                            )}

                            {item.evidence && (
                                <div className="change-historic-evidence">

                                    <div className="change-historic-evidence-header">
                                        <div className="change-historic-evidence-icon">
                                            <i className="pi pi-paperclip"></i>
                                        </div>

                                        <div>
                                            <span className="change-historic-evidence-title">
                                                Evidencia adjunta
                                            </span>

                                            <span className="change-historic-evidence-subtitle">
                                                Archivo relacionado con esta modificación
                                            </span>
                                        </div>
                                    </div>

                                    <div className="change-historic-evidence-body">

                                        {item.evidence.startsWith("data:application/pdf") ? (
                                            <iframe
                                                src={item.evidence}
                                                title={`Evidencia PDF ${index + 1}`}
                                                className="change-historic-evidence-pdf"
                                            />
                                        ) : item.evidence.startsWith("data:image") ? (
                                            <img
                                                src={item.evidence}
                                                alt={`Evidencia ${index + 1}`}
                                                className="change-historic-evidence-image"
                                            />
                                        ) : (
                                            <div className="change-historic-evidence-empty">
                                                <i className="pi pi-exclamation-triangle"></i>
                                                <span>Archivo no compatible</span>
                                            </div>
                                        )}

                                    </div>

                                </div>
                            )}

                        </div>

                    </div>
                ))}
            </Dialog>

            <Dialog
                visible={showMovementDialog}
                onHide={() => setShowMovementDialog(false)}
                modal
                draggable={false}
                resizable={false}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">

                            <div className="Global-dialog-icon">
                                <i className="pi pi-file-pdf"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Ticket
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={`Global-dialog Global-dialog Global-blue Global-small-v3 `}
                position="right"


            >
                <div className="cash-authorization-detail-container">

                    <Col sm="12"  >
                        <div style={{ transform: 'scale(0.9)', transformOrigin: 'top left' }}>
                            <Col sm="12" style={{ textAlign: "center" }} >
                                <img className="b-r-10" src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "35%" }} alt="logo" />
                            </Col>
                            <Row>
                                <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                    <label className='f-14 f-w-600'>{_commercialLine} </label> <br />
                                    <label style={{ fontSize: "11px" }} className=' f-w-600'>{_branchName} </label> <br />
                                    <div className='preview-cash-div' ></div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12" >
                                    <Col sm="12" style={{ textAlign: "center" }}>
                                        <label style={{ fontSize: "10px" }} >DETALLE</label>
                                    </Col>
                                    <div className="table-responsive">
                                        <Table className='table-sm table-stripped' >
                                            <thead>
                                                <tr style={{ backgroundColor: "#46AFE5" }}>
                                                    <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ color: "#000", textAlign: "center" }} > <label className='f-w-600 f-12'>Fecha de inicio</label></th>
                                                    <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>Fecha de corte</label></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className='text-center f-w-500' style={{ fontSize: "11px" }}>
                                                    <td>{_new ?? "---------"}</td>
                                                    <td>{_new ?? "---------"}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="table-responsive">
                                        <Table className='table-sm table-stripped' >
                                            <thead>
                                                <tr style={{ backgroundColor: "#46AFE5" }}>
                                                    <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>MÉTODO DE PAGO</label></th>
                                                    <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>TOTAL</label></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    infoTicket.pay_methods && infoTicket.pay_methods.length > 0 && infoTicket.pay_methods.map((_obj, _key) => {
                                                        _total_amount += _obj?.amount ?? 0
                                                        let lastPayMethod = infoTicket.pay_methods?.[infoTicket.pay_methods.length - 1];
                                                        _fech = lastPayMethod?.created_at ?? "---";
                                                        let methodName;
                                                        switch (_obj.id_pay_method) {
                                                            case 1:
                                                                methodName = "Efectivo";
                                                                break;
                                                            case 2:
                                                                methodName = "Tarjeta de Crédito";
                                                                break;
                                                            case 4:
                                                                methodName = "Tarjeta de Débito";
                                                                break;
                                                            case 8:
                                                                methodName = "Transferencia";
                                                                break;
                                                            default:
                                                                methodName = "Crédito";
                                                                break;
                                                        }
                                                        return (
                                                            <tr key={_key} className='text-center f-w-500' style={{ fontSize: "11px" }}>
                                                                <td>{methodName}</td>
                                                                <td>
                                                                    <label className='f-12 f-w-600'>
                                                                        {formatter.format(_obj.amount)}
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }

                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="table-responsive">
                                        <Table className='table-sm table-stripped' >
                                            <thead>
                                                <tr style={{ backgroundColor: "#46AFE5" }}>
                                                    <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle de movimientos</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className='f-12'> <b className='f-12'>Total</b></td>
                                                    <td className="text-center "><b className='f-12'>{formatter.format(_total_amount ?? 0)}</b></td>
                                                </tr>
                                                <tr>
                                                    <td className='f-12'> <b className='f-12'>Efectivo registrado</b></td>
                                                    <td className="text-center "><b className='f-12'> {formatter.format(formextemporaneus.amount ?? 0)}</b></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <br />
                                        <b htmlFor="">{formextemporaneus.comment ?? "--------"}</b>
                                    </div> <br /> <br />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }}>
                                    <div className='preview-cash-div' ></div>
                                    <label style={{ fontSize: "11px" }} className=' f-w-600'>{_nameUser} </label> <br />
                                </Col>
                            </Row>
                        </div>
                    </Col>

                </div>

            </Dialog>



            {showAlert && (
                <CustomAlertDialogGlobal
                    visible={showAlert}
                    title="Corte extemporane"
                    message={`No se puede realizar el corte extemporaneo <strong>Necesita colocar un  monto </strong> .`}
                    buttonText="Aceptar"
                    onAccept={cancelTabChange}
                    visibleOnCancel={false}
                />
            )}


            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />


            {
                <Modal className='pl-0 pr-0 pt-0 pb-0'
                    {...modalProps}>
                    <div
                        style={{
                            width: "100%",
                            height: "100vh",
                            background: "#fff",
                            display: "flex",
                            flexDirection: "column"
                        }}
                        className='pl-0 pr-0 pt-0 pb-0'
                    >
                        <div
                            style={{
                                padding: "15px 20px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #ddd"
                            }}
                            className='pl-0 pr-0 pt-0 pb-0'
                        >
                        </div>

                        <div
                            style={{
                                flex: 1,
                                overflow: "auto",
                                padding: 1
                            }}
                            className='pl-0 pr-0 pt-0 pb-0'
                        >
                            {
                                // * HEADER
                            }
                            <div className="cash-dashboard">
                                <div className="cash-dashboard-header">
                                    <div className="cash-dashboard-title-container">
                                        <div className="cash-dashboard-main-icon">
                                            <i className="fa fa-line-chart"></i>
                                        </div>

                                        <div>
                                            <h4 className="cash-dashboard-title">
                                                Cumplimiento de cortes de caja
                                            </h4>

                                            <span className="cash-dashboard-subtitle">
                                                Indicadores generales y cumplimiento por sucursal
                                            </span>
                                        </div>
                                    </div>

                                    <div className="cash-dashboard-date">
                                        <i className="fa fa-calendar mr-2"></i>
                                        Periodo seleccionado
                                    </div>
                                </div>

                                {loadingGlobal ? (
                                    <div className="cash-dashboard-loading">
                                        <i className="fa fa-spinner fa-spin"></i>
                                        <span>Cargando información de cortes...</span>
                                    </div>
                                ) : (
                                    <>
                                        <div className="cash-kpi-grid">

                                            <div className="cash-kpi-card cash-kpi-blue">
                                                <div className="cash-kpi-icon">
                                                    <i className="fa fa-building"></i>
                                                </div>

                                                <div className="cash-kpi-content">
                                                    <span className="cash-kpi-label">
                                                        Sucursales
                                                    </span>

                                                    <strong className="cash-kpi-value">
                                                        {cashDashboard.totalBranches}
                                                    </strong>

                                                    <small className="cash-kpi-description">
                                                        Sucursales evaluadas
                                                    </small>
                                                </div>
                                            </div>

                                            <div className="cash-kpi-card cash-kpi-green">
                                                <div className="cash-kpi-icon">
                                                    <i className="fa fa-check"></i>
                                                </div>

                                                <div className="cash-kpi-content">
                                                    <span className="cash-kpi-label">
                                                        Cortes cumplidos
                                                    </span>

                                                    <strong className="cash-kpi-value">
                                                        {cashDashboard.compliantBranches}
                                                    </strong>

                                                    <small className="cash-kpi-description">
                                                        Sin diferencia
                                                    </small>
                                                </div>
                                            </div>

                                            <div className="cash-kpi-card cash-kpi-orange">
                                                <div className="cash-kpi-icon">
                                                    <i className="fa fa-exclamation-triangle"></i>
                                                </div>

                                                <div className="cash-kpi-content">
                                                    <span className="cash-kpi-label">
                                                        Con diferencia
                                                    </span>

                                                    <strong className="cash-kpi-value">
                                                        {cashDashboard.differenceBranches}
                                                    </strong>

                                                    <small className="cash-kpi-description">
                                                        Requieren revisión
                                                    </small>
                                                </div>
                                            </div>

                                            <div className="cash-kpi-card cash-kpi-red">
                                                <div className="cash-kpi-icon">
                                                    <i className="fa fa-clock-o"></i>
                                                </div>

                                                <div className="cash-kpi-content">
                                                    <span className="cash-kpi-label">
                                                        Pendientes
                                                    </span>

                                                    <strong className="cash-kpi-value">
                                                        {cashDashboard.pendingBranches}
                                                    </strong>

                                                    <small className="cash-kpi-description">
                                                        Sin monto entregado
                                                    </small>
                                                </div>
                                            </div>

                                            <div className="cash-kpi-card cash-kpi-purple">
                                                <div className="cash-kpi-icon">
                                                    <i className="fa fa-percent"></i>
                                                </div>

                                                <div className="cash-kpi-content">
                                                    <span className="cash-kpi-label">
                                                        Cumplimiento
                                                    </span>

                                                    <strong className="cash-kpi-value">
                                                        {cashDashboard.compliancePercentage.toFixed(1)}%
                                                    </strong>

                                                    <small className="cash-kpi-description">
                                                        Cumplimiento general
                                                    </small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="cash-financial-summary">

                                            <div className="cash-financial-item">
                                                <div className="cash-financial-icon registered">
                                                    <i className="fa fa-money"></i>
                                                </div>

                                                <div>
                                                    <span>Efectivo registrado</span>

                                                    <strong>
                                                        {formatter.format(
                                                            cashDashboard.totalRegistered
                                                        )}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="cash-financial-item">
                                                <div className="cash-financial-icon cancelled">
                                                    <i className="fa fa-ban"></i>
                                                </div>

                                                <div>
                                                    <span>Efectivo cancelado</span>

                                                    <strong>
                                                        {formatter.format(
                                                            cashDashboard.totalCancelled
                                                        )}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="cash-financial-item">
                                                <div className="cash-financial-icon expected">
                                                    <i className="fa fa-calculator"></i>
                                                </div>

                                                <div>
                                                    <span>Efectivo final esperado</span>

                                                    <strong>
                                                        {formatter.format(
                                                            cashDashboard.totalExpected
                                                        )}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="cash-financial-item">
                                                <div className="cash-financial-icon delivered">
                                                    <i className="fa fa-handshake-o"></i>
                                                </div>

                                                <div>
                                                    <span>Monto entregado</span>

                                                    <strong>
                                                        {formatter.format(
                                                            cashDashboard.totalDelivered
                                                        )}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="cash-financial-item">
                                                <div
                                                    className={`cash-financial-icon ${Math.abs(cashDashboard.totalDifference) < 0.01
                                                        ? "balanced"
                                                        : "difference"
                                                        }`}
                                                >
                                                    <i
                                                        className={
                                                            Math.abs(cashDashboard.totalDifference) < 0.01
                                                                ? "fa fa-check"
                                                                : "fa fa-exclamation-triangle"
                                                        }
                                                    ></i>
                                                </div>

                                                <div>
                                                    <span>Diferencia general</span>

                                                    <strong
                                                        className={
                                                            Math.abs(cashDashboard.totalDifference) < 0.01
                                                                ? "cash-text-success"
                                                                : "cash-text-danger"
                                                        }
                                                    >
                                                        {formatter.format(
                                                            cashDashboard.totalDifference
                                                        )}
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="cash-compliance-card">
                                            <div className="cash-compliance-header">
                                                <div>
                                                    <strong>Cumplimiento general</strong>

                                                    <span>
                                                        {cashDashboard.compliantBranches} de{" "}
                                                        {cashDashboard.totalBranches -
                                                            cashDashboard.cancelledBranches}{" "}
                                                        sucursales cumplieron correctamente
                                                    </span>
                                                </div>

                                                <div className="cash-compliance-percentage">
                                                    {cashDashboard.compliancePercentage.toFixed(1)}%
                                                </div>
                                            </div>

                                            <div className="cash-progress">
                                                <div
                                                    className="cash-progress-value"
                                                    style={{
                                                        width: `${cashDashboard.compliancePercentage}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>

                                        <div className="cash-branches-grid">
                                            {(cashDashboard?.branchIndicators || []).map((branch, index) => {
                                                const isSelected =
                                                    selectedRow === branch?.id_branch;

                                                const percentage = Math.min(
                                                    Math.max(Number(branch?.percentage) || 0, 0),
                                                    100
                                                );

                                                const difference =
                                                    Number(branch?.difference) || 0;

                                                const usersCount =
                                                    branch?.detailBranches?.length || 0;

                                                const cashCount = (branch?.detailBranches || [])
                                                    .reduce(
                                                        (total, user) =>
                                                            total + (user?.cash?.length || 0),
                                                        0
                                                    );

                                                return (
                                                    <div
                                                        key={branch?.id_branch ?? index}
                                                        className={`cash-branch-card ${branch?.statusClass || ""
                                                            } ${isSelected
                                                                ? "cash-branch-card-selected"
                                                                : ""
                                                            }`}
                                                        onClick={() =>
                                                            handleRowSelect(branch?.id_branch)
                                                        }
                                                    >
                                                        {
                                                            // * HEADER
                                                        }
                                                        <div className="cash-branch-card-header">
                                                            <div className="cash-branch-identity">
                                                                <div className="cash-branch-number">
                                                                    {index + 1}
                                                                </div>

                                                                <div className="cash-branch-title">
                                                                    <strong>
                                                                        {branch?.branch ||
                                                                            "Sucursal sin nombre"}
                                                                    </strong>

                                                                    <span>
                                                                        Corte de caja
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div
                                                                className={`cash-status-badge ${branch?.statusClass || ""
                                                                    }`}
                                                            >
                                                                <i
                                                                    className={`${branch?.icon ||
                                                                        "fa fa-info-circle"
                                                                        } mr-1`}
                                                                ></i>

                                                                {branch?.status || "Sin estatus"}
                                                            </div>
                                                        </div>
                                                        {
                                                            // * AMOUNT
                                                        }
                                                        <div className="cash-branch-values">
                                                            <div className="cash-value-item cash-value-registered">
                                                                <span>
                                                                    <i className="fa fa-calculator"></i>
                                                                    Registrado
                                                                </span>

                                                                <strong>
                                                                    {formatter.format(
                                                                        Number(branch?.registered) || 0
                                                                    )}
                                                                </strong>
                                                            </div>

                                                            <div className="cash-value-item cash-value-cancelled">
                                                                <span>
                                                                    <i className="fa fa-ban"></i>
                                                                    Cancelado
                                                                </span>

                                                                <strong>
                                                                    {formatter.format(
                                                                        Number(branch?.cancelled) || 0
                                                                    )}
                                                                </strong>
                                                            </div>

                                                            <div className="cash-value-item cash-value-expected">
                                                                <span>
                                                                    <i className="fa fa-line-chart"></i>
                                                                    Esperado
                                                                </span>

                                                                <strong>
                                                                    {formatter.format(
                                                                        Number(branch?.expected) || 0
                                                                    )}
                                                                </strong>
                                                            </div>

                                                            <div className="cash-value-item cash-value-delivered">
                                                                <span>
                                                                    <i className="fa fa-check-circle"></i>
                                                                    Entregado
                                                                </span>

                                                                <strong>
                                                                    {formatter.format(
                                                                        Number(branch?.delivered) || 0
                                                                    )}
                                                                </strong>
                                                            </div>
                                                        </div>

                                                        {/* DIFERENCIA */}
                                                        <div
                                                            className={`cash-branch-difference ${Math.abs(difference) < 0.01
                                                                ? "cash-difference-success ml-0 mr-0"
                                                                : "cash-difference-danger ml-0 mr-0"
                                                                }`}
                                                        >
                                                            <div className="cash-difference-label">
                                                                <i
                                                                    className={
                                                                        Math.abs(difference) < 0.01
                                                                            ? "fa fa-check-circle"
                                                                            : "fa fa-exclamation-triangle"
                                                                    }
                                                                ></i>

                                                                <span>Diferencia</span>
                                                            </div>

                                                            <strong
                                                                className={
                                                                    Math.abs(difference) < 0.01
                                                                        ? "cash-text-success"
                                                                        : "cash-text-danger"
                                                                }
                                                            >
                                                                {formatter.format(difference)}
                                                            </strong>
                                                        </div>
                                                        <div className="cash-branch-progress-info pl-0">
                                                            <span>
                                                                Avance del corte
                                                            </span>

                                                            <strong>
                                                                {percentage.toFixed(0)}%
                                                            </strong>
                                                        </div>

                                                        <div className="cash-progress ml-0">
                                                            <div
                                                                className={`cash-progress-value ${branch?.statusClass || ""
                                                                    }`}
                                                                style={{
                                                                    width: `${percentage}%`
                                                                }}
                                                            ></div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        {
                                            // * USERS
                                        }
                                        <div className="cash-users-dashboard">

                                            <div className="cash-users-header">
                                                <div className="cash-users-title">
                                                    <div className="cash-users-main-icon">
                                                        <i className="fa fa-users"></i>
                                                    </div>

                                                    <div>
                                                        <h5>Cumplimiento de cortes por usuario</h5>

                                                        <span>
                                                            Seguimiento de cortes realizados, pendientes,
                                                            diferencias y validaciones
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="cash-users-filter">
                                                    <i className="fa fa-building-o"></i>

                                                    <select
                                                        value={selectedUserBranch}
                                                        onChange={(event) =>
                                                            setSelectedUserBranch(Number(event.target.value))
                                                        }
                                                    >
                                                        {userBranchOptions.map(option => (
                                                            <option
                                                                key={option.value}
                                                                value={option.value}
                                                            >
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            {
                                                // * DASHBOARD
                                            }
                                            <div className="cash-user-kpi-grid">

                                                <div className="cash-user-kpi-card blue">
                                                    <div className="cash-user-kpi-icon">
                                                        <i className="fa fa-users"></i>
                                                    </div>

                                                    <div>
                                                        <span>Usuarios evaluados</span>

                                                        <strong>
                                                            {userCashDashboard.totalUsers}
                                                        </strong>

                                                        <small>Usuarios con actividad</small>
                                                    </div>
                                                </div>

                                                <div className="cash-user-kpi-card green">
                                                    <div className="cash-user-kpi-icon">
                                                        <i className="fa fa-check"></i>
                                                    </div>

                                                    <div>
                                                        <span>Usuarios cumplidos</span>

                                                        <strong>
                                                            {userCashDashboard.compliantUsers}
                                                        </strong>

                                                        <small>Todos sus cortes cuadraron</small>
                                                    </div>
                                                </div>

                                                <div className="cash-user-kpi-card orange">
                                                    <div className="cash-user-kpi-icon">
                                                        <i className="fa fa-exclamation-triangle"></i>
                                                    </div>

                                                    <div>
                                                        <span>Con diferencias</span>

                                                        <strong>
                                                            {userCashDashboard.usersWithDifference}
                                                        </strong>

                                                        <small>Requieren revisión</small>
                                                    </div>
                                                </div>

                                                <div className="cash-user-kpi-card red">
                                                    <div className="cash-user-kpi-icon">
                                                        <i className="fa fa-clock-o"></i>
                                                    </div>

                                                    <div>
                                                        <span>Usuarios pendientes</span>

                                                        <strong>
                                                            {userCashDashboard.pendingUsers}
                                                        </strong>

                                                        <small>Con cortes sin realizar</small>
                                                    </div>
                                                </div>

                                                <div className="cash-user-kpi-card purple">
                                                    <div className="cash-user-kpi-icon">
                                                        <i className="fa fa-percent"></i>
                                                    </div>

                                                    <div>
                                                        <span>Cumplimiento general</span>

                                                        <strong>
                                                            {userCashDashboard.generalCompliance.toFixed(1)}%
                                                        </strong>

                                                        <small>Usuarios completamente cumplidos</small>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                // * PERCENTAGE

                                            }
                                            <div className="cash-user-general-progress">
                                                <div className="cash-user-progress-header">
                                                    <div>
                                                        <strong>
                                                            Cumplimiento general de usuarios
                                                        </strong>
                                                        <span>
                                                            {userCashDashboard.compliantUsers} de{" "}
                                                            {userCashDashboard.totalUsers} usuarios
                                                            cumplieron todos sus cortes
                                                        </span>
                                                    </div>

                                                    <strong className="cash-user-progress-percentage">
                                                        {userCashDashboard.generalCompliance.toFixed(1)}%
                                                    </strong>
                                                </div>

                                                <div className="cash-progress">
                                                    <div
                                                        className="cash-progress-value"
                                                        style={{
                                                            width: `${userCashDashboard.generalCompliance}%`
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                // * TABLE
                                            }
                                            <div className="cash-users-table-container">
                                                <div className="table-responsive">
                                                    <Table striped hover size="sm" className="cash-users-table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Usuario</th>
                                                                <th>Sucursal</th>
                                                                <th style={{ textAlign: "center" }}>
                                                                    Cortes
                                                                </th>
                                                                <th style={{ textAlign: "center" }}>
                                                                    Cumplimiento
                                                                </th>
                                                                <th style={{ textAlign: "center" }}>
                                                                    Estatus
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {usersDashboardFiltered.map((user, index) => {
                                                                const complied =
                                                                    user.pendingCuts === 0 &&
                                                                    user.differenceCuts === 0 &&
                                                                    user.totalCuts > 0;
                                                                return (
                                                                    <tr
                                                                        key={`${user.id_branch}-${user.id_user}-${index}`}
                                                                    >
                                                                        <td>{index + 1}</td>

                                                                        <td>
                                                                            <div className="cash-user-name-cell">
                                                                                <div className="cash-user-small-avatar">
                                                                                    <i className="fa fa-user"></i>
                                                                                </div>

                                                                                <strong>
                                                                                    {user.userName}
                                                                                </strong>
                                                                            </div>
                                                                        </td>

                                                                        <td>
                                                                            {user.branch}
                                                                        </td>

                                                                        <td style={{ textAlign: "center" }}>
                                                                            {user.balancedCuts} de {user.totalCuts}
                                                                        </td>

                                                                        <td style={{ textAlign: "center" }}>
                                                                            <div className="cash-user-mini-progress">
                                                                                <div
                                                                                    style={{
                                                                                        width: `${user.compliancePercentage}%`,
                                                                                        backgroundColor: complied
                                                                                            ? "#28a745"
                                                                                            : "#dc3545"
                                                                                    }}
                                                                                />
                                                                            </div>

                                                                            <small>
                                                                                {user.compliancePercentage.toFixed(0)}%
                                                                            </small>
                                                                        </td>

                                                                        <td style={{ textAlign: "center" }}>
                                                                            <span
                                                                                className={
                                                                                    complied
                                                                                        ? "cash-user-result success"
                                                                                        : "cash-user-result danger"
                                                                                }
                                                                            >
                                                                                <i
                                                                                    className={
                                                                                        complied
                                                                                            ? "fa fa-check-circle"
                                                                                            : "fa fa-times-circle"
                                                                                    }
                                                                                ></i>

                                                                                {complied
                                                                                    ? "Cumplió"
                                                                                    : "No cumplió"}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}

                                                            {usersDashboardFiltered.length === 0 && (
                                                                <tr>
                                                                    <td
                                                                        colSpan={6}
                                                                        style={{
                                                                            textAlign: "center",
                                                                            padding: "25px"
                                                                        }}
                                                                    >
                                                                        No existen usuarios para mostrar.
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                            <br /> <br /><br /><br />
                                            <br /> <br /><br /><br />
                                            {
                                                // * END TABLE
                                            }
                                            {usersDashboardFiltered.length === 0 && (
                                                <div className="cash-user-empty">
                                                    <i className="fa fa-users"></i>

                                                    <strong>No existen usuarios para mostrar</strong>

                                                    <span>
                                                        No se encontraron cortes para la sucursal seleccionada.
                                                    </span>
                                                </div>
                                            )}

                                        </div>
                                        {
                                            // * END USERS
                                        }

                                        {cashDashboard.branchIndicators.length === 0 && (
                                            <div className="cash-empty-state">
                                                <i className="fa fa-inbox"></i>

                                                <strong>No existen cortes registrados</strong>

                                                <span>
                                                    No se encontraron sucursales para el periodo
                                                    seleccionado.
                                                </span>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            {
                // ? DIALOG 
            }
            <Dialog
                visible={visibleInfo}
                style={{ width: '70vw' }}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">
                            <div className="Global-dialog-icon">
                                <i className="pi pi-money-bill"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Modificación de monto en corte de caja
                                </div>
                            </div>
                        </div>
                    </div>
                }
                className="Global-dialog Global-blue Global-medium3"
                maskClassName="custom-total-mask"
                closable={false}
                onHide={hideModalAmount}
                footer={footerContentDetail}>
                <Col sm="12" className='pl-0 pr-0' >

                    <div className={loadingExtemporaneous ? "d-none" : "cash-authorization-content"}  >
                        <div className="cash-authorization-company-card">
                            <div className="cash-authorization-company-icon">
                                <i className="fa fa-building-o"></i>
                            </div>

                            <div className="cash-authorization-company-information">
                                <span className="cash-authorization-section-label">
                                    MODIFICACIÓN DEL CORTE REALIZADO POR: <strong style={{ color: "#000" }} className='f-w-700'>{_nameUser ?? "Usuario no disponible"}</strong>
                                </span>

                                <h5 className="cash-authorization-company-name">
                                    {_commercialLine ?? "Sin línea comercial"}
                                </h5>

                                <span className="cash-authorization-branch-name">
                                    {_branchName ?? "Sin sucursal"}
                                </span>
                            </div>

                            <div className="cash-authorization-company-logo">
                                <img
                                    src={
                                        ConfigServer.serverUrl +
                                        "/api/Configuration/Logo"
                                    }
                                    alt="Logo"
                                />
                            </div>
                        </div>

                        {
                            // ? BODY TICKET
                        }
                        <div className="cash-authorization-detail-grid">
                            {
                                // ?  AMOUNT TO BE REPORTED
                            }



                            {
                                // * PAYMENT
                            }
                            <div className="cash-authorization-card">
                                <div className="cash-authorization-card-header">
                                    <div className="cash-authorization-card-header-icon cash-authorization-card-header-icon-green">
                                        <i className="fa fa-credit-card"></i>
                                    </div>

                                    <div>
                                        <h6 className="cash-authorization-card-title">
                                            Corte Actual
                                        </h6>


                                    </div>

                                    <span className="cash-authorization-level cash-authorization-level-green">
                                        {infoTicket?.pay_methods?.length ?? 0} métodos
                                    </span>
                                </div>

                                <div className="cash-authorization-payment-list">
                                    {infoTicket?.pay_methods?.length > 0 ? (
                                        infoTicket.pay_methods.map((_pay, _k) => {

                                            const payMethod = listPayMethod?.find(
                                                x => x.id_pay_method === _pay?.id_pay_method
                                            );

                                            const payMethodLabel = payMethod?.name ?? "Desconocido";

                                            let payMethodIcon = "fa-calendar-check-o";

                                            switch (_pay?.id_pay_method) {
                                                case 1:
                                                    payMethodIcon = "fa-money";
                                                    break;

                                                case 2:
                                                    payMethodIcon = "fa-credit-card";
                                                    break;

                                                case 4:
                                                    payMethodIcon = "fa-credit-card-alt";
                                                    break;

                                                case 7:
                                                    payMethodIcon = "fa-money";
                                                    break;

                                                case 8:
                                                    payMethodIcon = "fa-exchange";
                                                    break;

                                                case 10:
                                                    payMethodIcon = "fa-calendar-check-o";
                                                    break;

                                                case 30:
                                                    payMethodIcon = "fa-ticket";
                                                    break;

                                                default:
                                                    payMethodIcon = "fa-question-circle";
                                                    break;
                                            }

                                            return (
                                                <div
                                                    className="cash-authorization-payment-item"
                                                    key={`${_pay?.id_pay_method}-${_k}`}
                                                >
                                                    <div className="cash-authorization-payment-information">
                                                        <span className="cash-authorization-payment-icon">
                                                            <i className={`fa ${payMethodIcon}`}></i>
                                                        </span>

                                                        <span className="cash-authorization-payment-name">
                                                            {payMethodLabel}
                                                        </span>
                                                    </div>

                                                    <span className="cash-authorization-payment-amount">
                                                        {formatter.format(Number(_pay?.amount ?? 0))}
                                                    </span>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="cash-authorization-empty">
                                            <i className="fa fa-info-circle"></i>
                                            No existen métodos de pago registrados.
                                        </div>
                                    )}
                                </div>


                                <div className="cash-authorization-total">
                                    <div className="cash-authorization-total-information">
                                        <span className="cash-authorization-total-label">
                                            Efectivo entregado en corte:  <strong>
                                                {formatter.format(
                                                    Number(formNewAmount.amount_cut ?? 0)
                                                )}
                                            </strong>
                                        </span>
                                        <span className="cash-authorization-total-description">
                                            Suma de todos los métodos de pago
                                        </span>
                                    </div>

                                    <span className="cash-authorization-total-amount">
                                        {formatter.format(
                                            infoTicket?.pay_methods?.reduce(

                                                (total, item) =>
                                                    total + Number(item?.amount ?? 0),
                                                0
                                            ) ?? 0
                                        )}
                                    </span>
                                </div>
                            </div>

                            <div className="cash-authorization-authorization-card">
                                <div className="cash-authorization-authorization-header">
                                    <div className="cash-authorization-authorization-icon">
                                        <i className="fa fa-check-square-o"></i>
                                    </div>

                                    <div>
                                        <h6 className="cash-authorization-authorization-title">
                                            Modificación
                                        </h6>


                                    </div>
                                </div>

                                <div className="cash-authorization-authorization-gri">

                                    <div className="cash-authorization-information-item">
                                        <div className="cash-authorization-information-number">
                                            1
                                        </div>


                                        <div className="cash-authorization-information-content">
                                            <span className="cash-authorization-information-label">
                                                Modificación de monto
                                            </span>


                                            <span className="cash-authorization-information-label">
                                                <input value={formNewAmount.modifiedAmount} onChange={handleAmountModified} type="number" className='inputCash f-12' placeholder='Ingrese la cantidad' name="modifiedAmount" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="cash-authorization-information-item pr-0">
                                        <div className="cash-authorization-information-number cash-authorization-information-number-green">
                                            2
                                        </div>

                                        <div className="cash-authorization-information-content">
                                            <span className="cash-authorization-information-label">
                                                Justificación de la modificación
                                            </span>
                                            <textarea
                                                className='form-control form-control-sm input-air-primary'
                                                name="observation"
                                                rows="3"
                                                value={formNewAmount.observation ?? ""}
                                                onChange={handleCommentModified}
                                                style={{ fontSize: "12px" }}
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </Col>
            </Dialog>





        </Fragment >
    )
}



